// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  width: 100%;
  height: 100vh;
  background: #0A131D;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container .login-boxer {
  width: 380px;
  max-width: 90%;
}
.login-container .logo {
  max-width: 250px;
}
.user-dropdown {
  cursor: pointer;
}
.user-dropdown .user-label {
  color: #ffffff;
  margin: 0;
}
@media (max-width: 576px) {
  .user-dropdown .user-label {
    width: 40px;
  }
}
.header-content-main {
  padding-bottom: 10px;
}
.card-folder-item {
  overflow: hidden;
  cursor: pointer;
}
.card-folder-item .folder-item-container {
  width: 100%;
  overflow: hidden;
}
.card-folder-item .folder-item-container .folder-item-name {
  width: calc(100% - 25px);
}
.card-file-item {
  overflow: hidden;
}
.card-file-item .card-cover {
  object-fit: contain;
  object-position: center;
}
.card-file-item .card-cover-dox {
  height: 100px;
  width: 100%;
  font-size: 60px;
  display: flex !important;
}
.skeleton-file-media {
  width: 100% !important;
  height: 100% !important;
}
.skeleton-file-media .card-file-item {
  width: 100%;
  height: 100%;
}
.skeleton-file-media .card-cover-dox {
  font-size: 60px;
  color: #bfbfbf;
}
.skeleton-file-media .card-cover-dox {
  height: 100px;
  width: 100%;
  font-size: 60px;
  display: flex !important;
}
.attachment-detail-container .attachment-info {
  height: calc(100vh - 250px);
  overflow: auto;
}
.media-modal-container,
.media-model-detail-file {
  height: 96% !important;
  overflow: hidden !important;
  top: 30px !important;
}
.media-modal-container .ant-modal-content,
.media-model-detail-file .ant-modal-content {
  background-color: #f5f5f5 !important;
}
.media-modal-container .ant-modal-content .ant-modal-header,
.media-model-detail-file .ant-modal-content .ant-modal-header {
  background-color: #f5f5f5 !important;
}
.file-media-selected .card-file-item {
  border: 2px solid #1677ff;
}
.select-multiple-file-container {
  margin-bottom: 24px;
}
.select-multiple-file-container .file-selected {
  border-radius: 6px;
  border: 1px solid #d9d9d9;
}
.select-multiple-file-container .file-selected .file-selected-view {
  padding: 20px;
  overflow: auto;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item {
  height: 110px;
  overflow: hidden;
  position: relative;
}
@media (min-width: 2560px) {
  .select-multiple-file-container .file-selected .file-selected-view .image-view-item {
    height: 180px;
  }
}
@media (max-width: 576px) {
  .select-multiple-file-container .file-selected .file-selected-view .image-view-item {
    height: 80px;
  }
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item .image-ant {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d9d9d9;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item .image-ant image {
  max-width: 100%;
  max-height: 100%;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item .close-image-view {
  position: absolute;
  z-index: 100;
  top: -1px;
  right: 4px;
  color: #23282D;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  color: #ff4d4f;
}
.select-multiple-file-container .file-selected .file-selected-view .image-view-item:hover .close-image-view {
  visibility: visible;
  opacity: 1;
}
.select-multiple-file-container .file-selected .file-selected-control {
  padding: 12px 20px;
  border-top: 1px solid #d9d9d9;
}
.select-multiple-file-container .ant-form-item-control-input {
  min-height: unset !important;
}
.select-single-file-container {
  position: relative;
  margin-bottom: 24px;
}
.select-single-file-container .card-file-single-cover {
  display: flex;
  padding: 10px;
}
.select-single-file-container .card-file-single-cover img {
  max-width: 200px;
}
.select-single-file-container .action-file-single {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 25px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  z-index: 100;
  line-height: 25px;
}
.select-single-file-container:hover .action-file-single {
  opacity: 1;
  visibility: visible;
}
.select-single-file-container .ant-form-item-control-input {
  min-height: unset !important;
}
body {
  margin: 0;
}
.loading-data-main {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lazy-loading-main {
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.date-picker-input {
  width: 100%;
}
.ant-notification-topRight {
  z-index: 10000000000;
}
.my-message-cms-top {
  z-index: 10000000000;
}
@media (max-width: 576px) {
  .chrome-picker {
    width: 100% !important;
    max-width: 225px !important;
  }
}
@media (max-width: 576px) {
  .ant-form-item-control {
    flex: 0 0 100% !important;
    max-width: 100%;
  }
}
.active {
  background-color: #e6f7ff !important;
}
.active * {
  background-color: #e6f7ff !important;
}
.inactive {
  opacity: 0.5;
}
.custom-table .ant-table-thead > tr > th {
  padding: 5px;
}
.custom-table .ant-table-tbody > tr > td {
  padding: 5px;
}
/*# sourceMappingURL=styles.css.map */`, "",{"version":3,"sources":["webpack://./pages/login.less","webpack://./src/styles/styles.less","webpack://./components/user-dropdown.less","webpack://./components/header-content.less","webpack://./components/card-media-item.less","webpack://./components/select-file-media.less","webpack://./styles.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;ADPA;EAQI,YAAA;EACA,cAAA;ACEJ;ADXA;EAYI,gBAAA;ACEJ;ACdA;EACE,eAAA;ADgBF;ACjBA;EAGI,cAAA;EACA,SAAA;ADiBJ;AChBI;EAAA;IACE,WAAA;EDmBJ;AACF;AE1BA;EACE,oBAAA;AF4BF;AG7BA;EACE,gBAAA;EACA,eAAA;AH+BF;AGjCA;EAII,WAAA;EACA,gBAAA;AHgCJ;AGrCA;EAOM,wBAAA;AHiCN;AG5BA;EACE,gBAAA;AH8BF;AG/BA;EAGI,mBAAA;EACA,uBAAA;AH+BJ;AGnCA;EAOI,aAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AH+BJ;AG3BA;EACE,sBAAA;EACA,uBAAA;AH6BF;AG/BA;EAII,WAAA;EACA,YAAA;AH8BJ;AGnCA;EAQI,eAAA;EACA,cAAA;AH8BJ;AGvCA;EAYI,aAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AH8BJ;AG1BA;EAEI,2BAAA;EACA,cAAA;AH2BJ;AGtBA;;EACE,sBAAA;EACA,2BAAA;EACA,oBAAA;AHyBF;AG5BA;;EAKI,oCAAA;AH2BJ;AGhCA;;EAOM,oCAAA;AH6BN;AGxBA;EAEI,yBAAA;AHyBJ;AI5FA;EACE,mBAAA;AJ8FF;AI/FA;EAGI,kBAAA;EACA,yBAAA;AJ+FJ;AInGA;EAMM,aAAA;EACA,cAAA;AJgGN;AIvGA;EASQ,aAAA;EACA,gBAAA;EACA,kBAAA;AJiGR;AIhGQ;EAAA;IACE,aAAA;EJmGR;AACF;AIlGQ;EAAA;IACE,YAAA;EJqGR;AACF;AItHA;EAmBU,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AJsGV;AI9HA;EA0BY,eAAA;EACA,gBAAA;AJuGZ;AIlIA;EA+BU,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AJsGV;AIpGQ;EAEI,mBAAA;EACA,UAAA;AJqGZ;AInJA;EAoDM,kBAAA;EACA,6BAAA;AJkGN;AIvJA;EAyDI,4BAAA;AJiGJ;AI7FA;EACE,kBAAA;EACA,mBAAA;AJ+FF;AIjGA;EAII,aAAA;EACA,aAAA;AJgGJ;AIrGA;EAOM,gBAAA;AJiGN;AIxGA;EAWI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AJgGJ;AI9FE;EAEI,UAAA;EACA,mBAAA;AJ+FN;AIvHA;EA6BI,4BAAA;AJ6FJ;AKpLA;EACE,SAAA;ALsLF;AKnLA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALqLF;AKlLA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALoLF;AKjLA;EACE,WAAA;ALmLF;AKjLA;EACE,oBAAA;ALmLF;AKjLA;EACE,oBAAA;ALmLF;AK/KE;EAAA;IACE,sBAAA;IACA,2BAAA;ELkLF;AACF;AK9KE;EAAA;IACE,yBAAA;IACA,eAAA;ELiLF;AACF;AK9KA;EACE,oCAAA;ALgLF;AKjLA;EAGI,oCAAA;ALiLJ;AK9KA;EACE,YAAA;ALgLF;AK9KA;EAEI,YAAA;AL+KJ;AKjLA;EAKI,YAAA;AL+KJ;AACA,qCAAqC","sourcesContent":[".login-container{\n  width: 100%;\n  height: 100vh;\n  background: #0A131D;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .login-boxer{\n    width: 380px;\n    max-width: 90%;\n  }\n  .logo{\n    max-width: 250px;\n  }\n}\n",".login-container {\n  width: 100%;\n  height: 100vh;\n  background: #0A131D;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login-container .login-boxer {\n  width: 380px;\n  max-width: 90%;\n}\n.login-container .logo {\n  max-width: 250px;\n}\n.user-dropdown {\n  cursor: pointer;\n}\n.user-dropdown .user-label {\n  color: #ffffff;\n  margin: 0;\n}\n@media (max-width: 576px) {\n  .user-dropdown .user-label {\n    width: 40px;\n  }\n}\n.header-content-main {\n  padding-bottom: 10px;\n}\n.card-folder-item {\n  overflow: hidden;\n  cursor: pointer;\n}\n.card-folder-item .folder-item-container {\n  width: 100%;\n  overflow: hidden;\n}\n.card-folder-item .folder-item-container .folder-item-name {\n  width: calc(100% - 25px);\n}\n.card-file-item {\n  overflow: hidden;\n}\n.card-file-item .card-cover {\n  object-fit: contain;\n  object-position: center;\n}\n.card-file-item .card-cover-dox {\n  height: 100px;\n  width: 100%;\n  font-size: 60px;\n  display: flex !important;\n}\n.skeleton-file-media {\n  width: 100% !important;\n  height: 100% !important;\n}\n.skeleton-file-media .card-file-item {\n  width: 100%;\n  height: 100%;\n}\n.skeleton-file-media .card-cover-dox {\n  font-size: 60px;\n  color: #bfbfbf;\n}\n.skeleton-file-media .card-cover-dox {\n  height: 100px;\n  width: 100%;\n  font-size: 60px;\n  display: flex !important;\n}\n.attachment-detail-container .attachment-info {\n  height: calc(100vh - 250px);\n  overflow: auto;\n}\n.media-modal-container,\n.media-model-detail-file {\n  height: 96% !important;\n  overflow: hidden !important;\n  top: 30px !important;\n}\n.media-modal-container .ant-modal-content,\n.media-model-detail-file .ant-modal-content {\n  background-color: #f5f5f5 !important;\n}\n.media-modal-container .ant-modal-content .ant-modal-header,\n.media-model-detail-file .ant-modal-content .ant-modal-header {\n  background-color: #f5f5f5 !important;\n}\n.file-media-selected .card-file-item {\n  border: 2px solid #1677ff;\n}\n.select-multiple-file-container {\n  margin-bottom: 24px;\n}\n.select-multiple-file-container .file-selected {\n  border-radius: 6px;\n  border: 1px solid #d9d9d9;\n}\n.select-multiple-file-container .file-selected .file-selected-view {\n  padding: 20px;\n  overflow: auto;\n}\n.select-multiple-file-container .file-selected .file-selected-view .image-view-item {\n  height: 110px;\n  overflow: hidden;\n  position: relative;\n}\n@media (min-width: 2560px) {\n  .select-multiple-file-container .file-selected .file-selected-view .image-view-item {\n    height: 180px;\n  }\n}\n@media (max-width: 576px) {\n  .select-multiple-file-container .file-selected .file-selected-view .image-view-item {\n    height: 80px;\n  }\n}\n.select-multiple-file-container .file-selected .file-selected-view .image-view-item .image-ant {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #d9d9d9;\n}\n.select-multiple-file-container .file-selected .file-selected-view .image-view-item .image-ant image {\n  max-width: 100%;\n  max-height: 100%;\n}\n.select-multiple-file-container .file-selected .file-selected-view .image-view-item .close-image-view {\n  position: absolute;\n  z-index: 100;\n  top: -1px;\n  right: 4px;\n  color: #23282D;\n  font-size: 20px;\n  cursor: pointer;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.3s;\n  color: #ff4d4f;\n}\n.select-multiple-file-container .file-selected .file-selected-view .image-view-item:hover .close-image-view {\n  visibility: visible;\n  opacity: 1;\n}\n.select-multiple-file-container .file-selected .file-selected-control {\n  padding: 12px 20px;\n  border-top: 1px solid #d9d9d9;\n}\n.select-multiple-file-container .ant-form-item-control-input {\n  min-height: unset !important;\n}\n.select-single-file-container {\n  position: relative;\n  margin-bottom: 24px;\n}\n.select-single-file-container .card-file-single-cover {\n  display: flex;\n  padding: 10px;\n}\n.select-single-file-container .card-file-single-cover img {\n  max-width: 200px;\n}\n.select-single-file-container .action-file-single {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 25px;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.3s;\n  z-index: 100;\n  line-height: 25px;\n}\n.select-single-file-container:hover .action-file-single {\n  opacity: 1;\n  visibility: visible;\n}\n.select-single-file-container .ant-form-item-control-input {\n  min-height: unset !important;\n}\nbody {\n  margin: 0;\n}\n.loading-data-main {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.lazy-loading-main {\n  width: 100%;\n  height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.date-picker-input {\n  width: 100%;\n}\n.ant-notification-topRight {\n  z-index: 10000000000;\n}\n.my-message-cms-top {\n  z-index: 10000000000;\n}\n@media (max-width: 576px) {\n  .chrome-picker {\n    width: 100% !important;\n    max-width: 225px !important;\n  }\n}\n@media (max-width: 576px) {\n  .ant-form-item-control {\n    flex: 0 0 100% !important;\n    max-width: 100%;\n  }\n}\n.active {\n  background-color: #e6f7ff !important;\n}\n.active * {\n  background-color: #e6f7ff !important;\n}\n.inactive {\n  opacity: 0.5;\n}\n.custom-table .ant-table-thead > tr > th {\n  padding: 5px;\n}\n.custom-table .ant-table-tbody > tr > td {\n  padding: 5px;\n}\n/*# sourceMappingURL=styles.css.map */",".user-dropdown {\n  cursor: pointer;\n  .user-label{\n    color: #ffffff;\n    margin: 0;\n    @media(max-width: 576px) {\n      width: 40px;\n    }\n  }\n}\n",".header-content-main{\n  padding-bottom: 10px;\n}\n",".card-folder-item {\n  overflow: hidden;\n  cursor: pointer;\n  .folder-item-container {\n    width: 100%;\n    overflow: hidden;\n    .folder-item-name {\n      width: calc(100% - 25px);\n    }\n  }\n}\n\n.card-file-item {\n  overflow: hidden;\n  .card-cover {\n    object-fit: contain;\n    object-position: center;\n  }\n  .card-cover-dox {\n    height: 100px;\n    width: 100%;\n    font-size: 60px;\n    display: flex !important;\n  }\n}\n\n.skeleton-file-media {\n  width: 100% !important;\n  height: 100% !important;\n  .card-file-item {\n    width: 100%;\n    height: 100%;\n  }\n  .card-cover-dox {\n    font-size: 60px;\n    color: #bfbfbf;\n  }\n  .card-cover-dox {\n    height: 100px;\n    width: 100%;\n    font-size: 60px;\n    display: flex !important;\n  }\n}\n\n.attachment-detail-container {\n  .attachment-info {\n    height: calc(100vh - 250px);\n    overflow: auto;\n  }\n}\n\n\n.media-modal-container,.media-model-detail-file {\n  height: 96% !important;\n  overflow: hidden !important;\n  top: 30px !important;\n  .ant-modal-content {\n    background-color: #f5f5f5 !important;\n    .ant-modal-header {\n      background-color: #f5f5f5 !important;\n    }\n  }\n}\n\n.file-media-selected {\n  .card-file-item {\n    border: 2px solid #1677ff;\n  }\n}\n\n.file-media-not-selected{}\n",".select-multiple-file-container{\n  margin-bottom: 24px;\n  .file-selected{\n    border-radius: 6px;\n    border: 1px solid #d9d9d9;\n    .file-selected-view{\n      padding: 20px;\n      overflow: auto;\n      .image-view-item {\n        height: 110px;\n        overflow: hidden;\n        position: relative;\n        @media(min-width: 2560px){\n          height: 180px;\n        }\n        @media(max-width: 576px){\n          height: 80px;\n        }\n        .image-ant {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background-color: #d9d9d9;\n          image {\n            max-width: 100%;\n            max-height: 100%;\n          }\n        }\n        .close-image-view{\n          position: absolute;\n          z-index: 100;\n          top: -1px;\n          right: 4px;\n          color: #23282D;\n          font-size: 20px;\n          cursor: pointer;\n          opacity: 0;\n          visibility: hidden;\n          transition: .3s;\n          color: #ff4d4f;\n        }\n        &:hover {\n          .close-image-view{\n            visibility: visible;\n            opacity: 1;\n          }\n        }\n      }\n    }\n    .file-selected-control{\n      padding: 12px 20px;\n      border-top: 1px solid #d9d9d9;\n    }\n  }\n  .ant-form-item-control-input {\n    min-height: unset !important;\n  }\n}\n\n.select-single-file-container{\n  position: relative;\n  margin-bottom: 24px;\n  .card-file-single-cover {\n    display: flex;\n    padding: 10px;\n    img{\n      max-width: 200px;\n    }\n  }\n  .action-file-single {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 25px;\n    opacity: 0;\n    visibility: hidden;\n    transition: .3s;\n    z-index: 100;\n    line-height: 25px;\n  }\n  &:hover{\n    .action-file-single{\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: unset !important;\n  }\n}\n","@import './pages';\n@import './components';\n\nbody {\n  margin: 0;\n}\n\n.loading-data-main {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lazy-loading-main {\n  width: 100%;\n  height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.date-picker-input {\n  width: 100%;\n}\n.ant-notification-topRight {\n  z-index: 10000000000;\n}\n.my-message-cms-top {\n  z-index: 10000000000;\n}\n\n.chrome-picker {\n  @media (max-width: 576px) {\n    width: 100% !important;\n    max-width: 225px !important;\n  }\n}\n\n.ant-form-item-control {\n  @media (max-width: 576px) {\n    flex: 0 0 100% !important;\n    max-width: 100%;\n  }\n}\n\n.active {\n  background-color: #e6f7ff !important;\n  * {\n    background-color: #e6f7ff !important;\n  }\n}\n.inactive {\n  opacity: 0.5;\n}\n.custom-table {\n  .ant-table-thead>tr>th {\n    padding: 5px;\n  }\n  .ant-table-tbody>tr>td {\n    padding: 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
